import styles from './Card.module.css';

const Card = (props) => {
  const classes = `${styles.card} ${props.className}`;

  return <div onClick={props.onClick} className={classes}>{props.children}</div>;
};

export default Card;
